@if (isCategoryPage) {
  @if (CategoryService.model$| async; as model) {
    @if (model?.breadcrumbs && model.breadcrumbs.length > 0) {
      <div class="facet-outer">
        @if (model?.breadcrumbs && model?.breadcrumbs.length > 0) {
          <div id="cx-active-facets-groupName" class="facetActiveheading"
            >
            {{'common.search_nav_applied_facets'|cxTranslate}}
          </div>
        }
        @for (facet of model.breadcrumbs; track facet) {
          <a routerLink="./" (click)="FacetClick(facet, model)"
            [cxFocus]="{ key: getFocusKey(model, facet) }" role="button"
          (keydown.space)="removeFilterWithSpacebar($event)" [attr.aria-label]="
        'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }
      ">
            <span>{{ facet.facetValueName }}</span>
            <cx-icon aria-hidden="true" [type]="closeIcon"></cx-icon>
          </a>
        }
      </div>
    }
  }
} @else {
  @if (productListService.countDetails$|async; as facetData) {
    @if (this.facetTabIndex==0) {
      @if (facetData?.productModel) {
        @if (facetData?.productModel.breadcrumbs && facetData?.productModel.breadcrumbs.length > 0) {
          <div class="facet-outer">
            @if (facetData?.productModel.breadcrumbs && facetData?.productModel.breadcrumbs.length > 0) {
              <div id="cx-active-facets-groupName" class="facetActiveheading"
                >
                {{'common.search_nav_applied_facets'|cxTranslate}}
              </div>
            }
            @for (facet of facetData?.productModel?.breadcrumbs; track facet) {
              <a routerLink="./"
                (click)="FacetClick(facet, facetData?.productModel)"
                [cxFocus]="{ key: getFocusKey(facetData?.productModel, facet) }" role="button"
              (keydown.space)="removeFilterWithSpacebar($event)" [attr.aria-label]="
          'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }
        ">
                <span>{{ facet.facetValueName }}</span>
                <cx-icon aria-hidden="true" [type]="closeIcon"></cx-icon>
              </a>
            }
          </div>
        }
      }
    }
    <!-- Active facet for other tabs -->
    @if (this.facetTabIndex==1) {
      @if (facetData?.crossRefModel) {
        @if (facetData?.crossRefModel.breadcrumbs && facetData?.crossRefModel.breadcrumbs.length > 0) {
          @if (facetData?.crossRefModel.breadcrumbs) {
            <div class="facet-outer">
              @if (facetData?.crossRefModel.breadcrumbs && facetData?.crossRefModel.breadcrumbs.length > 0) {
                <div id="cx-active-facets-groupName" class="facetActiveheading"
                  >
                  {{'common.search_nav_applied_facets'|cxTranslate}}
                </div>
              }
              @for (facet of facetData?.crossRefModel?.breadcrumbs; track facet) {
                <a routerLink="./" (click)="FacetClick(facet)"
                  [cxFocus]="{ key: getFocusKey(facetData?.crossRefModel, facet) }" role="button"
              (keydown.space)="removeFilterWithSpacebar($event)" [attr.aria-label]="
          'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }
        ">
                  <span>{{ facet.facetValueName }}</span>
                  <cx-icon aria-hidden="true" [type]="closeIcon"></cx-icon>
                </a>
              }
            </div>
          }
        }
      }
    }
    @if (this.facetTabIndex==2) {
      @if (facetData?.docModel) {
        @if (facetData?.docModel?.breadcrumbs && facetData?.docModel?.breadcrumbs.length > 0) {
          @if (facetData?.docModel?.breadcrumbs) {
            <div class="facet-outer">
              @if (facetData?.docModel?.breadcrumbs && facetData?.docModel?.breadcrumbs.length > 0) {
                <div id="cx-active-facets-groupName" class="facetActiveheading"
                  >
                  {{'common.search_nav_applied_facets'|cxTranslate}}
                </div>
              }
              @for (facet of facetData?.docModel?.breadcrumbs; track facet) {
                <a routerLink="./" (click)="FacetClick(facet)"
                  [cxFocus]="{ key: getFocusKey(facetData?.docModel, facet) }" role="button"
              (keydown.space)="removeFilterWithSpacebar($event)" [attr.aria-label]="
          'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }
        ">
                  <span>{{ facet.facetValueName }}</span>
                  <cx-icon aria-hidden="true" [type]="closeIcon"></cx-icon>
                </a>
              }
            </div>
          }
        }
      }
    }
    @if (this.facetTabIndex==3) {
      @if (facetData?.softwareModel) {
        @if (facetData?.softwareModel?.breadcrumbs && facetData?.softwareModel?.breadcrumbs.length > 0) {
          @if (facetData?.softwareModel?.breadcrumbs) {
            <div class="facet-outer">
              @if (facetData?.softwareModel?.breadcrumbs && facetData?.softwareModel?.breadcrumbs.length > 0) {
                <div id="cx-active-facets-groupName" class="facetActiveheading"
                  >
                  {{'common.search_nav_applied_facets'|cxTranslate}}
                </div>
              }
              @for (facet of facetData?.softwareModel?.breadcrumbs; track facet) {
                <a routerLink="./" (click)="FacetClick(facet)"
                  [cxFocus]="{ key: getFocusKey(facetData?.softwareModel, facet) }" role="button"
              (keydown.space)="removeFilterWithSpacebar($event)" [attr.aria-label]="
          'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }
        ">
                  <span>{{ facet.facetValueName }}</span>
                  <cx-icon aria-hidden="true" [type]="closeIcon"></cx-icon>
                </a>
              }
            </div>
          }
        }
      }
    }
  }
  <!-- seperateDocDetails -->
  @if (this.facetTabIndex==7) {
    @if (productListService.seperateDocDetails$|async; as facetData) {
      @if (facetData?.breadcrumbs && facetData?.breadcrumbs.length > 0) {
        @if (facetData?.breadcrumbs) {
          <div class="facet-outer">
            @if (facetData?.breadcrumbs && facetData?.breadcrumbs.length > 0) {
              <div id="cx-active-facets-groupName" class="facetActiveheading"
                >Applied Facets
              </div>
            }
            @for (facet of facetData?.breadcrumbs; track facet) {
              <a routerLink="./" (click)="FacetClick(facet)"
                [cxFocus]="{ key: getFocusKey(facetData, facet) }" role="button"
            (keydown.space)="removeFilterWithSpacebar($event)" [attr.aria-label]="
        'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }">
                <span>{{ facet.facetValueName }}</span>
                <cx-icon aria-hidden="true" [type]="closeIcon"></cx-icon>
              </a>
            }
          </div>
        }
      }
    }
  }
  <!-- seperateDocDetails Ends -->
  <!-- seperateSoftDetails -->
  @if (this.facetTabIndex==8) {
    @if (productListService.seperateSoftDetails$|async; as facetData) {
      @if (facetData?.breadcrumbs && facetData?.breadcrumbs.length > 0) {
        @if (facetData?.breadcrumbs) {
          <div class="facet-outer">
            @if (facetData?.breadcrumbs && facetData?.breadcrumbs.length > 0) {
              <div id="cx-active-facets-groupName" class="facetActiveheading"
                >{{'common.search_nav_applied_facets'|cxTranslate}}
              </div>
            }
            @for (facet of facetData?.breadcrumbs; track facet) {
              <a routerLink="./" (click)="FacetClick(facet)"
                [cxFocus]="{ key: getFocusKey(facetData, facet) }" role="button"
            (keydown.space)="removeFilterWithSpacebar($event)" [attr.aria-label]="
          'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }">
                <span>{{ facet.facetValueName }}</span>
                <cx-icon aria-hidden="true" [type]="closeIcon"></cx-icon>
              </a>
            }
          </div>
        }
      }
    }
  }
  <!-- seperateSoftDetails Ends -->
  @if (productListService.SteeringProdDetails$|async; as facetData) {
    @if (this.facetTabIndex==9) {
      @if (facetData?.productModel) {
        @if (facetData?.productModel.breadcrumbs && facetData?.productModel.breadcrumbs.length > 0) {
          <div class="facet-outer">
            @if (facetData?.productModel.breadcrumbs && facetData?.productModel.breadcrumbs.length > 0) {
              <div id="cx-active-facets-groupName" class="facetActiveheading"
                >
                {{'common.search_nav_applied_facets'|cxTranslate}}
              </div>
            }
            @for (facet of facetData?.productModel?.breadcrumbs; track facet) {
              <a routerLink="./"
                (click)="FacetClick(facet, facetData?.productModel)"
                [cxFocus]="{ key: getFocusKey(facetData?.productModel, facet) }" role="button"
              (keydown.space)="removeFilterWithSpacebar($event)" [attr.aria-label]="
          'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }
        ">
                <span>{{ facet.facetValueName }}</span>
                <cx-icon aria-hidden="true" [type]="closeIcon"></cx-icon>
              </a>
            }
          </div>
        }
      }
    }
  }
  @if (productListService.FormulaProdDetails$|async; as facetData) {
    @if (this.facetTabIndex==10) {
      @if (facetData?.productModel) {
        @if (facetData?.productModel.breadcrumbs && facetData?.productModel.breadcrumbs.length > 0) {
          <div class="facet-outer">
            @if (facetData?.productModel.breadcrumbs && facetData?.productModel.breadcrumbs.length > 0) {
              <div id="cx-active-facets-groupName" class="facetActiveheading"
                >
                {{'common.search_nav_applied_facets'|cxTranslate}}
              </div>
            }
            @for (facet of facetData?.productModel?.breadcrumbs; track facet) {
              <a routerLink="./"
                (click)="FacetClick(facet, facetData?.productModel)"
                [cxFocus]="{ key: getFocusKey(facetData?.productModel, facet) }" role="button"
              (keydown.space)="removeFilterWithSpacebar($event)" [attr.aria-label]="
        'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }
      ">
                <span>{{ facet.facetValueName }}</span>
                <cx-icon aria-hidden="true" [type]="closeIcon"></cx-icon>
              </a>
            }
          </div>
        }
      }
    }
  }
}

